"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_modal_1 = __importDefault(require("react-modal"));
require("./style.css");
var Modal = function (_a) {
    var children = _a.children, isOpen = _a.isOpen, onClose = _a.onClose;
    return (react_1.default.createElement(react_modal_1.default, { isOpen: isOpen, className: "syl-modal", shouldFocusAfterRender: true, onRequestClose: onClose, ariaHideApp: false, style: {
            content: {
                top: '20%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: '#fff',
                position: 'absolute',
                boxShadow: '0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)',
                borderRadius: '4px'
            },
            overlay: {
                background: 'rgba(0, 0, 0, 0.5)',
                zIndex: 6
            }
        } }, children));
};
exports.Modal = Modal;
var ModalTitle = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: "syl-modal-title" }, children));
};
exports.ModalTitle = ModalTitle;
var ModalContent = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: "syl-modal-content" }, children));
};
exports.ModalContent = ModalContent;
var ModalFooter = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: "syl-modal-footer" }, children));
};
exports.ModalFooter = ModalFooter;
//# sourceMappingURL=index.js.map